class UserFriendlyAPIError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UserFriendlyAPIError";
  }
}

export default UserFriendlyAPIError;
